import React from 'react'
import { Col, Drawer, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { PrimaryButton } from 'Components/button'
import { InfoCircleOutlined } from '@ant-design/icons'

type Props = {
  children: any
  title?: React.ReactNode
  onCloseDrawer?: () => void
  visible: boolean
  footer?: React.ReactNode
  width?: string
  maskClosable?: boolean
  isShowTutorial?: boolean
  showTutorial?: boolean
  onClickStart?: () => void
}

const DetailDrawer: React.FunctionComponent<Props> = props => {
  const {
    children,
    title = '',
    onCloseDrawer = () => {},
    footer = null,
    visible,
    width = '50%',
    maskClosable = false,
    isShowTutorial = false,
    showTutorial = false,
    onClickStart = () => {},
  } = props
  const breakpoint = useBreakpoint()
  const xl = breakpoint.xl || false
  return (
    <Drawer
      title={
        isShowTutorial ? null : (
          <Row justify="space-between" align="top">
            <Col>{title}</Col>
            {showTutorial && (
              <Col>
                <PrimaryButton
                  text="แนะนำการใช้งาน"
                  btnType="Cancel"
                  icon={<InfoCircleOutlined />}
                  onClick={() => onClickStart()}
                  size="middle"
                />
              </Col>
            )}
          </Row>
        )
      }
      width={xl ? width : '100%'}
      onClose={onCloseDrawer}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={footer}
      maskClosable={maskClosable}
    >
      {children}
    </Drawer>
  )
}

export default DetailDrawer
